import React from 'react';
import { Form, FormGroup, Col, Row, Button, InputGroup, FormControl, ControlLabel, Checkbox, Glyphicon } from 'react-bootstrap';
import Select from 'react-select';
import './style.scss';
import CallOffItems from './CallOffItems';
import constants from '../../util/constants';
import axios from 'axios';
import moment from 'moment';
import LoadingSpinner from '../../LoadingSpinner';
import _ from 'underscore';
import NPSpinnerModal from '../../NPSpinnerModalBetter';
import Dialog from 'react-bootstrap-dialog';
import ReactGA from 'react-ga';
import classHelper from '../../util/class.helper';
import DayPickerInputWithAddon from '../../DayPickerInputWithAddon'
// import "react-day-picker/lib/style.css";

const { API_BASE_URL } = constants;

class CallOffCreate extends React.Component {
    constructor(props) {
        super(props);

        this.close = this.close.bind(this);
        this.getcombo = this.getcombo.bind(this);
        this.refresh = this.refresh.bind(this);
        this.getLegalEntity = this.getLegalEntity.bind(this);
        this.getClientCodeData = this.getClientCodeData.bind(this);
        this.handleClientSelectChange = this.handleClientSelectChange.bind(this);
        this.closeModalAction = this.closeModalAction.bind(this);
        this.setEndCountry = this.setEndCountry.bind(this);

        this.state = {
            disabled: false,
            selectedCustomerValue: '',
            isLoading: true,
            callOffValue: false,
            viewOrderTexts: false,
            otherInfoCollapsed: true,
            viewOrderTextsCollapsed: true,
            showSpinnerModal: false,
            closeModalAction: this.closeModalAction,
            setSaveOk: false,
            cw_mark: false,
            fsc: false,
            pefc: false,
            legalEntity: '',
            userType: '',
            caption: '',

            CLIENT_CODE_REGIONAL: null,
            LOADING_NO: null,
            STATUS_ID: null,
            CONTAINER_TYPE_ID: null,
            TRANSPORT_TYPE_ID: null,
            ESTIM_ARRIVAL_DATE: moment(),
            END_COUNTRY: null,
            SHIPPING_INFORMATION: null,
            COST_OF_DELIVERY: null,

            callOffItems: [],
            availableCallOffItems: [],
            availableCallOffItemsLoading: false,

            hasPresetCCR: true,
            hasNewRow: false,
            clientCodeList: [],
            callOffClient: {},
            callOffCountry: '',
            callOffWrapper: {},
        };
        this.getLegalEntity();

        this.header = {
            'Authorization': 'Bearer ' + this.props.apiToken,
            'Accept': 'application/octet-stream'
        };
    }

    async componentDidMount() {
        const self = this;
        const prevCallOff = this.props.callOff;
        const prevOrder = this.props.callOffOrder;

        this.axiosCancelSource = axios.CancelToken.source();
        await this.getClientCodeData(self)
            .then(res => {
                if (prevCallOff && prevCallOff.LOADING_NO) {
                    // Modify
                    this.getCallOffWrapper(prevCallOff.LOADING_NO)
                }
                else if (prevOrder && prevOrder.CLIENT_CODE_REGIONAL) {
                    // Create with template
                    this.getCallOffWrapperNew(prevOrder.CLIENT_CODE_REGIONAL, prevOrder);
                }
                else {
                    // New
                    this.setState({
                        hasPresetCCR: false,
                        isLoading: false,
                        caption: "Create new Call Off"
                    })
                }
            })
    }

    getLegalEntity() {
        this.setState({ legalEntity: window.sessionStorage.getItem('LegalEntity'), userType: window.sessionStorage.getItem('UserType') });
    }

    close() {
        this.props.callOffFunctions.toggle();
    }

    notOkToSave(state) {
        if (state.selectedCustomerValue == undefined) return true
        if (state.callOffItems == undefined || state.callOffItems.length == 0) return true

        let hasError = false
        state.callOffItems.forEach(x => {
            if (x.ORDER_NUMBER == undefined) hasError = true
            if (x.ORDERED_BY == undefined) hasError = true
            if (x.PLANNED_QUANTITY == 0 || x.PLANNED_WEIGHT_UC == 0) hasError = true
        })

        if (hasError) return true
        return false
    }

    addMinusAndStrIfStr(str) {
        return str !== null && str !== "" ? ' - ' + str : "";
    }

    async getClientCodeData(self) {
        return await axios.get(API_BASE_URL + 'OrderEntry/GetClientCodeInfo', { headers: this.header })
            .then(result => {
                if (result.data == null || result.data == undefined) {
                    self.setState({ stillLoading: false });
                    return;
                }

                let clientCodeList = result.data.ClientCodes;
                if (clientCodeList) {
                    clientCodeList = clientCodeList.filter(d => d.MAIN_CLIENT === 1).map(d => ({
                        label: d.CLIENT_CODE_REGIONAL + ' - ' + d.SHORT_NAME + this.addMinusAndStrIfStr(d.DELIVERY_DESTINATION),
                        value: d
                    }));

                    self.state["clientCodeList"] = clientCodeList;
                }

                self.state["stillLoading"] = false;
                self.forceUpdate();
            });
    }

    getCallOffWrapper(loadingNo) {
        const self = this;
        const { API_BASE_URL } = constants;

        axios.get(API_BASE_URL + `Calloff/GetCallOffWrapper/?loadingNo=${loadingNo}`, { headers: this.header })
            .then(result => {
                let header = result.data.Header;
                let availableCallOffItems = result.data.AvailableOrderItems;
                let callOffItems = result.data.CallOffItems;
                let selectedCustomer = self.state.clientCodeList.find(x => x.label.includes(header.CLIENT_CODE_REGIONAL))

                // If Modify add ORDER_BY Quantity as default for each order
                if (callOffItems) {
                    callOffItems.forEach(x => {
                        x.ORDERED_BY = { label: 'Quantity', value: 'Q' }
                    })
                }

                self.setState({
                    CLIENT_CODE_REGIONAL: header.CLIENT_CODE_REGIONAL,
                    LOADING_NO: header.LOADING_NO,
                    STATUS_ID: header.STATUS_IDSTATUS_ID,
                    ESTIM_ARRIVAL_DATE: header.ESTIM_ARRIVAL_DATE,
                    END_COUNTRY: header.END_COUNTRY,
                    SHIPPING_INFORMATION: header.SHIPPING_INFORMATION,
                    COST_OF_DELIVERY: header.COST_OF_DELIVERY,

                    callOffItems: callOffItems,
                    availableCallOffItems: availableCallOffItems,

                    selectedCustomerValue: selectedCustomer ? selectedCustomer : header.CLIENT_CODE_REGIONAL,
                    caption: 'Modify call off',

                    availableCallOffItemsLoading: false,
                    isLoading: false
                })
            })
            .catch(error => {
                if (error.response) {
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                }
                else {
                    console.log('no error.response');
                }
                self.setState({
                    availableCallOffItemsLoading: false,
                    isLoading: false
                });
                //alert("Error getting order");
                self.close();
            });

    }

    getCallOffWrapperNew(ccr, prevOrder) {
        const self = this;
        self.setState({ availableCallOffItemsLoading: true });
        const { API_BASE_URL } = constants;

        axios.get(API_BASE_URL + `Calloff/GetCallOffWrapperNew/?clientCodeRegional=${ccr}`, { headers: this.header })
            .then(result => {
                let header = result.data.Header;
                let availableCallOffItems = result.data.AvailableOrderItems;
                let callOffItems = [];
                let selectedCustomer = self.state.clientCodeList.find(x => x.label.includes(header.CLIENT_CODE_REGIONAL))

                // If Create new call off with order as template - add order
                if (prevOrder) {
                    const orderToAddToCallOff = availableCallOffItems.find(x => x.ORDER_COMBO == prevOrder.ORDER_COMBO)

                    if (orderToAddToCallOff == null) return
                    orderToAddToCallOff.ORDERED_BY = { label: 'Quantity', value: 'Q' }
                    callOffItems.push(orderToAddToCallOff)
                }

                self.setState({
                    CLIENT_CODE_REGIONAL: header.CLIENT_CODE_REGIONAL,
                    LOADING_NO: header.LOADING_NO > 0 ? header.LOADING_NO : '',
                    END_COUNTRY: header.END_COUNTRY,
                    callOffItems: callOffItems,
                    availableCallOffItems: availableCallOffItems,

                    selectedCustomerValue: selectedCustomer ? selectedCustomer : header.CLIENT_CODE_REGIONAL,
                    caption: 'Create call off',

                    availableCallOffItemsLoading: false,
                    isLoading: false
                })
            })
            .catch(error => {
                if (error.response) {
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                }
                else {
                    console.log('no error.response');
                }
                self.setState({
                    availableCallOffItemsLoading: false,
                    isLoading: false
                });
                alert("Error getting order");
                console.log("Error getting order", error);
                self.close();
            });

    }

    save(self, release) {
        this.setState({ showSpinnerModal: true, saveInProgress: true });
        const { API_BASE_URL } = constants
        let callOffItems = this.state.callOffItems.map(item => ({
            LOADING_NO: item.LOADING_NO || -1,
            ORDER_NUMBER: item.ORDER_NUMBER,
            ORDER_ITEM_NUMBER: item.ORDER_ITEM_NUMBER,
            QUANTITY: -1,
            PLANNED_QUANTITY: item.PLANNED_QUANTITY || 0,
            AVAILABLE_QUANTITY: item.AVAILABLE_QUANTITY || -1,
            WEIGHT: -1,
            PLANNED_WEIGHT: item.PLANNED_WEIGHT || 0,
            PLANNED_WEIGHT_UC: item.PLANNED_WEIGHT_UC || 0,
            AVAILABLE_WEIGHT: -1,
            AVAILABLE_WEIGHT_UC: -1,
            PRODUCT_CODE: item.PRODUCT_CODE,
            PALLET_LOCATION_AREA: item.PALLET_LOCATION_AREA
        }))
        let callOffWrapper = {
            Header: {
                CLIENT_CODE_REGIONAL: this.state.CLIENT_CODE_REGIONAL || "",
                LOADING_NO: this.state.LOADING_NO || -1,
                STATUS_ID: this.state.STATUS_ID || -1,
                CONTAINER_TYPE_ID: -1,
                TRANSPORT_TYPE_ID: -1,
                ESTIM_ARRIVAL_DATE: this.state.ESTIM_ARRIVAL_DATE || "",
                END_COUNTRY: this.state.END_COUNTRY || "",
                SHIPPING_INFORMATION: this.state.SHIPPING_INFORMATION || "",
                COST_OF_DELIVERY: this.state.COST_OF_DELIVERY || -1
            },
            CallOffItems: callOffItems || [],
            Environment: process.env.REACT_APP_BASE_CATALOG,
            Release: release
        }

        axios.post(API_BASE_URL + 'CallOff/SaveCallOff', JSON.stringify(callOffWrapper),
            {
                headers: { ...this.header, 'Content-Type': 'application/json' }
            })
            .then(result => {
                let message = (release ? 'Released call off ' : callOffWrapper.Header.LOADING_NO != -1 ? 'Modified call off ' : 'Created call off ') + result.data.toString();
                this.setState({ modalContent: message, saveInProgress: false, setSaveOk: true, savedId: result.data });
                this.GAtrackHandler(self, release);
            })
            .catch(error => {
                let errorMessage = error?.response?.status === 400 && error?.response?.data || "An error occured during save, please try again later.";
                if (error.response) {
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                }
                else {
                    console.log('no error.response');
                }

                this.setState({ modalContent: errorMessage, saveInProgress: false });
            });
    }

    handleClientSelectChange(item) {
        if (!item.value) return false;

        this.setState({
            selectedCustomerValue: item ? item : {}
        })
        this.getCallOffWrapperNew(item.value.CLIENT_CODE_REGIONAL);
    }

    getcombo(_caption, _stateObj, _onChange, _placeHolder, _options, _clearable = true, disabled = false) {
        return (
            <FormGroup className="select">
                <InputGroup className="margin-left-10 margin-top-4" bsSize="sm"><InputGroup.Addon>{_caption}</InputGroup.Addon>
                    <Select isSearchable={true} isClearable={_clearable} resetValue=''
                        styles={classHelper.dropdownCreateForm()}
                        isDisabled={disabled}
                        value={this.state[_stateObj] || ''} onChange={(item) => _onChange(item, _stateObj)}
                        options={_options} placeholder={_placeHolder} />
                </InputGroup>
            </FormGroup>
        );
    }

    getinfo(_caption, _stateObj, _readonly = false, _multirow = false, _width = "auto", dobreak = false, _height = "", maxlen = null) {
        let clname = dobreak ? " col-lg-1" : "";
        let clname2 = "margin-left-10 margin-top-4" + clname;
        return (
            <FormGroup bsSize="sm">
                <InputGroup className={clname2} bsSize="sm">
                    <InputGroup.Addon className={clname}>{_caption}</InputGroup.Addon>
                    <FormControl
                        bsSize="sm"
                        componentClass={_multirow ? "textarea" : "input"}
                        style={{ width: _width, height: _height }}
                        readOnly={_readonly}
                        tabIndex={_readonly ? -1 : null}
                        value={this.state[_stateObj] || ''}
                        title={this.state[_stateObj]}
                        placeholder={_readonly ? '' : _caption}
                        maxLength={maxlen}
                        onChange={(e) => this.setState({ [_stateObj]: e.target.value })}
                    />
                </InputGroup>
            </FormGroup>
        );
    }

    getvalueFromState(_stateObj, self) {
        return (this.state[_stateObj] !== undefined && this.state[_stateObj]);
    }

    refresh() {
        this.setState({});
    }

    GAtrackHandler(e, r) {
        ReactGA.event({
            category: "User action",
            action: e ? "User created a call off " + r ? " and released it" : " and saved it" : "User created a call off but cancelled it",
        })
    }

    closeModalAction() {
        this.setState({
            showSpinnerModal: false,
            modalLoading: false,
            modalContent: null,
            modalTitle: null
        })

        this.close()
    }

    setEndCountry(country) {
        this.state({ END_COUNTRY: country });
    }

    //Om vi vill validera ETA input
    // isValid(value){
    //     let regex = /^20[1-9][0-9]-([0-1][0-9]|[0-9])-[0-9][0-9]$/g;
    //     let d = value != undefined && value != null ? moment(value).format('YYYY-MM-DD') : null;
    //     if(d != null){
    //         return d.match(regex);
    //     }
    //     return false;
    // }

    render() {
        const { isLoading, callOffItems, availableCallOffItems, availableCallOffItemsLoading } = this.state
        let { disabled } = this.state
        let grid = (availableCallOffItems || callOffItems) && availableCallOffItemsLoading == false ?
            <CallOffItems disabled={this.state.disabled}
                parentRefresh={this.refresh}
                callOffItems={callOffItems}
                availableCallOffItems={availableCallOffItems}
                availableCallOffItemsLoading={availableCallOffItemsLoading}
                userType={this.state.userType}
                legalEntity={this.state.legalEntity}
                setEndCountry={this.setEndCountry}
                apiToken={this.props.apiToken} /> :
            <LoadingSpinner isLoading={true} />;

        if (this.state.selectedCustomerValue == '')
            grid = undefined

        const eta = this.state.ESTIM_ARRIVAL_DATE && moment(this.state.ESTIM_ARRIVAL_DATE).format('YYYY-MM-DD');

        return (
            <div>
                <Dialog ref={(el) => { this.dialog = el }} />
                <NPSpinnerModal showModal={this.state.showSpinnerModal} title="Saving" content={this.state.modalContent} closeAction={this.closeModalAction} isLoading={this.state.saveInProgress} />

                <Row><div className="center-block text-center"><span style={{ "fontSize": "16px", "fontWeight": "600" }}>{this.state.caption}</span></div></Row>

                {isLoading &&
                    <LoadingSpinner isLoading={true} />
                }

                {isLoading == false &&
                    <Row>
                        <Form inline onSubmit={evt => { evt.preventDefault(); }}>
                            <Col xs={12}>
                                <fieldset className="myfieldset smaller-inputs">
                                    <legend className="mylegend">Call off info</legend>
                                    <div className="pull-Left margin-right-30">
                                        <Row><Col>{this.getcombo('Client', "selectedCustomerValue", this.handleClientSelectChange, 'Client', this.state.clientCodeList, false, this.state.hasPresetCCR ? true : false)}</Col></Row>
                                        <Row><Col>{this.getinfo('Loading no.', 'LOADING_NO', disabled = true, false, "300px")}</Col></Row>
                                        <Row><Col>
                                            <FormGroup className="margin-left-10">
                                                <InputGroup bsSize="small">
                                                    <DayPickerInputWithAddon
                                                        className={'form-control'}
                                                        label="ETA"
                                                        small
                                                        format="YYYY-MM-DD"
                                                        placeholder="YYYY MM DD"
                                                        value={eta}
                                                        onChange={(selectedDay) => {
                                                            this.setState({ ESTIM_ARRIVAL_DATE: selectedDay })
                                                        }
                                                        }
                                                    />
                                                    {/* <DayPickerInputWithAddon
                                                        value={eta}
                                                        label="ETA"
                                                        placeholder="YYYY MM DD"
                                                        onChange={(newDate) => this.setState({ ESTIM_ARRIVAL_DATE: newDate })} /> */}
                                                </InputGroup>
                                            </FormGroup>
                                        </Col></Row>

                                        <Row><Col>{this.getinfo('Shipping information', 'SHIPPING_INFORMATION', false, true, "300px", false, "60px", 500)}</Col></Row>
                                    </div>
                                    <div className="pull-Left margin-right-30">
                                        <Row><Col>{this.getinfo('Country', 'END_COUNTRY', disabled = true, false, "300px")}</Col></Row>
                                    </div>
                                </fieldset>
                            </Col>
                        </Form>

                        <Col sm={12}>
                            <Form>
                                <FormGroup>
                                    <fieldset className="myfieldset">
                                        <legend className="mylegend">
                                            Orders
                                    </legend>

                                        <Row className="unflow-table">
                                            <Col xs={12}>
                                                {grid}
                                            </Col>
                                        </Row>
                                    </fieldset>

                                    <Row className="margin-top-10">
                                        <Col xs={12}>
                                            <Button bsStyle="primary" disabled={this.notOkToSave(this.state)} onClick={evt => { this.save(this, false); }}>
                                                Save
                                    </Button>
                                            <Button bsStyle="primary" disabled={this.notOkToSave(this.state)} className="margin-left-10" onClick={evt => { this.save(this, true); }}>
                                                Save and release
                                    </Button>
                                            <Button bsStyle="primary" onClick={this.close} className="margin-left-10">
                                                Close
                                    </Button>
                                        </Col>
                                    </Row>

                                </FormGroup>
                            </Form>
                        </Col>
                    </Row>
                }

            </div>
        )
    }
}

export default CallOffCreate;